import {
  PROFILE_KEY,
  updateProfileAction
} from '@gymaholic/packages'
import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'

const ACTION_TYPE = {
  UPDATE_INJURIES: 'UPDATE_INJURIES'
}

export function updateInjuriesProfileAction (value) {
  return updateProfileAction({
    type: getActionStrReduxUtil(ACTION_TYPE.UPDATE_INJURIES, value),
    payload: {
      key: PROFILE_KEY.INJURIES,
      value
    }
  })
}
